import Toastr from '../../../itrust_common/components/Toastr';

const DEFAULT_STATE = {
  check_postings: [],
  check_posting: null,
  meta: { pagination: {}, kpis: {} },
  saving: false,
};

let changes = null;

export default function checkPostingReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response);

  switch (action.type) {
    case 'CHECK_POSTINGS_LOAD_PENDING':
    case 'CHECK_POSTING_CREATE_PENDING':
    case 'CHECK_POSTING_DESTROY_PENDING':
      return { ...state, saving: true };

    case 'CHECK_POSTING_LOAD_PENDING':
      return { ...state, check_posting: null };

    case 'CHECK_POSTINGS_LOAD_REJECTED':
    case 'CHECK_POSTING_CREATE_REJECTED':
    case 'CHECK_POSTING_DESTROY_REJECTED':
    case 'CHECK_POSTING_LOAD_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code);
      return { ...state, saving: false };

    case 'CHECK_POSTING_LOAD_FULFILLED':
      return { ...state, check_posting: response.check_posting };

    case 'CHECK_POSTINGS_LOAD_FULFILLED':
      changes = {
        ...response,
        saving: false,
      };
      return { ...state, ...changes };

    case 'CHECK_POSTING_CREATE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201);
      return { ...state, saving: false };

    case 'CHECK_POSTING_DESTROY_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201);
      return { ...state, saving: false };

    case 'RESET_CHECK_POSTING':
      return DEFAULT_STATE;

    default:
      return state;
  }
}
